<template>
<div> 
  <b-modal id="modalAddEdit" size="lg" v-model="showModal" centered   no-close-on-esc no-close-on-backdrop hide-header-close
      ok-variant cancel-variant hide-footer
      header-class="PopUpHeader" 
      :body-bg-variant=PopUpVar.bodyBgVariant
      :body-text-variant=PopUpVar.bodyTextVariant
      :footer-bg-variant=PopUpVar.footerBgVariant
      :footer-text-variant=PopUpVar.footerTextVariant> 
    <template slot="modal-header" > 
      <div  style="margin: 0 auto;">
        <small class="PopUpTitle w-100 text-center"> {{PopUpTitle}}</small>
      </div> 
    </template>
    <UsersAdd v-if="ShowAdd" @finished="finished"></UsersAdd>
    <UsersEdit v-if="ShowEdit" @finished="finished" v-bind:UserData="this.UserData"></UsersEdit> 
</b-modal>  
<Subtitle  v-bind:ServiceID="this.AppServiceID">
<template v-slot:header> 
<i class="fas fa-user-shield"></i><b>  Manage Users:</b>
</template> 
</Subtitle> 
<Card>
  <CardBody>
    <p>Manage Users is an Administration action. Any change in this section will affect the web application and its access level. All transactions are monitored, logged and reviewed.
    </p>
</CardBody>
</Card> 


 <v-client-table :columns="columns" :data="tableData" :options="options">

   <template slot="status" slot-scope="props">
  <span>{{ props.row.status }}</span>
   </template>

    <div slot="beforeFilter"  class="VueTables_Adduser">
        <label for="VueTables_Adduser" class="VueTables_user"> Add New User: </label>
          <button type="button" v-on:click="AddUserPopup" class="btn btn-primary form-control ">ADD USER</button>
          
     </div>
      <span class="pointer" v-on:click="EditUser(props.row)" slot="edit" slot-scope="props" > <i class="far fa-edit"></i></span>  
    </v-client-table>
</div>
</template>
<script>
 
import {mapGetters} from 'vuex'
import axios from 'axios'
import Vue from 'vue';
import moment from 'moment'
import Modal from '@/Common/ModelPop.vue';
import UsersAdd from '@/components/DPEBB/Administrator/UsersAdd.vue';
import UsersEdit from '@/components/DPEBB/Administrator/UsersEdit.vue';
import { PopUpVariant } from '@/Common/Default/PopUpVariant'
import Card from "@/Common/Card.vue";
import CardBody from "@/Common/CardBody.vue";
import TileNote from "@/Common/TileNote.vue";
import Subtitle from '@/Common/Default/SubTitle.vue';  
export default {
  methods: {
    EditUser(row){
      this.PopUpTitle = "Edit User";
      this.UserData = {Recid: row.recid, ClinicNo:row.clinicno,UserName:row.username,UserFullname:row.userfullname,ServiceType:row.servicetype,RoleId:row.role}
      this.ShowAdd = false;
      this.ShowEdit = true;    
      this.showModal = true;
    }, 
    AddUserPopup(){
       this.PopUpTitle = "Add New User";
        this.ShowAdd = true;
        this.ShowEdit = false; 
        this.showModal = true;
    }, 
    finished() {
    //console.log('at close')
    this.ShowAdd = false;
    this.ShowEdit = false; 
    this.showModal = false;
    var vm = this;
      axios.get('/SaskHealthApi/security/GetAllUsers?_='+Date.now(), { headers: { 'Authorization': 'Bearer ' + localStorage.access_token }})
      .then(function (response) {
            vm.tableData=response.data;
        })
        .catch(function (er) {
            console.log(er)
        });
    }
    },
    
  components: {
        Modal:Modal,
        UsersAdd:UsersAdd,
          Card,
          CardBody,
          TileNote,           
           Subtitle,
           UsersEdit
    },
    computed:{ 
    },
  data: function () {
    return {
      PopUpTitle:'Add New User',
      ShowAdd :false,
      ShowEdit: false,
        SearchClinics:'Search Clinics',
        AppServiceID :6,
        Locations:[],
        UserData:'',
        isModalVisible: true,
        showModal: false,
        PopUpVar:PopUpVariant,
        searchloc:'',
        columns: ['status','edit','username', 'userfullname','role','servicetype','clinicno','clinicname','effectivedate','expirydate','createdby','createddate','lastmodifiedby','modifieddate'],
        tableData: [],
        options: {
        texts:{
              count:"Showing {from} to {to} of {count} records|{count} records|One record",
              first:'First',
              last:'Last',
              filter:"Search User Data:",
              filterPlaceholder:"Search in table",
              limit:"Records:",
              page:"Page:",
              noResults:"No matching records",
              filterBy:"Filter by {column}",
              loading:'Loading...',
              defaultOption:'Select {column}',
              columns:'Columns'
          },
          responseAdapter({data}) {
            // const formatData = data.map(o => {
            //     const dataCopy = JSON.parse(JSON.stringify(o))
            //     dataCopy.expirydate = moment(o.expirydate).format('MMMM Do YYYY')
            //     return dataCopy
            //   })
              return {
                data: formatData,
                count: data.length
              };
              // return {
              //   data,
              //   count: data.length
              // }
            },
         // skin:'table table-hover',
          perPage:10,
          perPageValues:[10,15,25],
          dateColumns:['expirydate','effectivedate'],
          //toMomentFormat: 'YYYY/MM/DD',
          //templates: {edit: 'edit'},
          templates: {
            expirydate(h, row) {
             // moment.locale('es');               
              return moment(row.expirydate,"YYYY-MM-DD").format('YYYY/MM/DD');  
            },
            effectivedate(h, row) {
             // moment.locale('es');               
              return moment(row.effectivedate,"YYYY-MM-DD").format('YYYY/MM/DD');  
            },
            createddate(h, row) {          
              return moment(row.createddate,"YYYY-MM-DD").format('YYYY/MM/DD');  
            },
            modifieddate(h, row) {          
              return moment(row.modifieddate,"YYYY-MM-DD").format('YYYY/MM/DD');  
            },
          },
          headings: {
            edit: 'Edit',
            username: 'User ID',
            userfullname: 'User Name',
            rolename:  'Role',
            servicename: 'Service Type',
            clinicno:    'Clinic #',
            clinicname:   'Clinic Name',
            effectivedate: 'Effective Date',
            expirydate: 'Expiry Date',
            createdby: 'Created By',
            createddate: 'Created Date',
            lastmodifiedby: 'Last Modified By',
            modifieddate: 'Last Modified Date',
            servicetype: ' Service Type'
          },
          pagination: {
            edge: true,
            nav: 'scroll',
            chunk: 5
          },
          sortable: ['status','username', 'userfullname','role','servicetype','clinicno','clinicname','effectivedate','expirydate','createdby','createddate','lastmodifiedby','modifieddate'],
          filterable: ['status','username','userfullname','role','servicetype','clinicno','clinicname','effectivedate','expirydate'],
          sortIcon: {
                  base : 'fas',
                  is: 'fa-sort',
                  up: 'fa-sort-up',
                  down: 'fa-sort-down'
                  },
          }
    }
  },
 mounted: function () {
     this.$nextTick(function () {
      //  var vm = this; 
      //   axios.get('/SaskHealthApi/Codes/GetClinics', { headers: { 'Authorization': 'Bearer ' + localStorage.access_token }})
      //       .then(function (response) {
      //           // console.log(response.data);
      //          // vm.Locations = response.data
      //           // console.log(response);
      //       })
      //   .catch(function (er) {
      //       console.log(er)
      //   })   
      })
    },
    created () {
       this.finished(); 
    },
}

</script>
 <style lang="scss" scoped>
#app {
  font-family: "Roboto", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  padding: 2em 1em;
}

.options {
  text-align: left;
  padding: 1em 0em;
} 
</style>

 
 